import { put, select } from "redux-saga/effects";
import { isCorpTenant } from "@capone/common";
import { actions } from "../../actions";
import {
  getSelectedPaymentMethodId,
  getPaymentMethodRewardsAccountId,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";

import { deletePaymentMethod } from "../../../../api/v0/book/payment-methods/deletePaymentMethod";
import { getViewedTripSummaryProperties } from "../../../shop/reducer";
import { getRewardsAccounts } from "../../../rewards/reducer";
import { config } from "../../../../api/config";

export function* deletePaymentMethodSaga({
  paymentId,
}: actions.IDeletePaymentMethod) {
  try {
    const state: IStoreState = yield select();

    const selectedPaymentMethodId = getSelectedPaymentMethodId(state);
    const hadPaymentMethodSelected =
      selectedPaymentMethodId && selectedPaymentMethodId !== "";

    yield deletePaymentMethod({ paymentId });
    yield put(actions.deletePaymentMethodCallStateSuccess());

    const viewedTripSummaryProperties = getViewedTripSummaryProperties(state);
    const paymentMethodRewardsAccountId =
      getPaymentMethodRewardsAccountId(state);

    if (selectedPaymentMethodId === paymentId) {
      yield put(
        actions.setSelectedPaymentMethodId({
          paymentMethodId: undefined,
          accountId: paymentMethodRewardsAccountId,
          multiTicketType: viewedTripSummaryProperties?.multi_ticket_type,
        })
      );
    }

    yield put(actions.listPaymentMethods());

    if (hadPaymentMethodSelected && isCorpTenant(config.TENANT)) {
      const updatedState: IStoreState = yield select();
      const { paymentMethods } = updatedState.flightBook;

      if (paymentMethods && paymentMethods.length > 0) {
        const firstPaymentMethod = paymentMethods[0];

        const rewardsAccounts = getRewardsAccounts(updatedState);
        const matchingRewardsAccount = rewardsAccounts.find(
          (account) =>
            account.lastFour === firstPaymentMethod.last4 ||
            (firstPaymentMethod.last4 &&
              account.lastFourVirtualCardNumbers?.includes(
                firstPaymentMethod.last4
              ))
        );

        yield put(
          actions.setSelectedPaymentMethodId({
            paymentMethodId: firstPaymentMethod.id,
            accountId: matchingRewardsAccount?.accountReferenceId,
            multiTicketType: viewedTripSummaryProperties?.multi_ticket_type,
          })
        );
      }
    }
  } catch (e) {
    yield put(actions.deletePaymentMethodCallStateFailed());
  }
}
